/**
 * Represents a filter category with options
 */
export class FilterCategoryView<T = string> {
	constructor(
		public readonly name: string,
		public readonly options: T[],
		public readonly isMultiSelect: boolean = true
	) {}
}
